






















import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class MasterSideBar extends Vue {
  public hasLicenseCurrency: boolean = false;
  
  public created() {
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
  }
}
